import React from 'react';
import styled, { ThemeProvider } from 'styled-components';
import './App.css';

import theme from '../theme';

import data from '../assets/data.json';

const Container = styled.div`
  display: block;
  width: 100%;
  height: 100%;
  margin: 0;
  background: white;
  text-align: left;
`;

/**
 * This component is the root component for the whole application.
 *
 * @class App
 * @extends {React.Component}
 */
class App extends React.Component {
  constructor(props) {
    super(props);

    const envType = process.env.REACT_APP_TYPE;
    const config = data.searchWidgetConfig[envType || 'DEV'];
    const resourceRoot = config.resourceRoot;

    const manifestScriptEl = document.createElement('script');
    manifestScriptEl.type = 'text/javascript';
    manifestScriptEl.src = `${resourceRoot}/veeva-network-manifest.js`;

    const widgetLoaderScriptEl = document.createElement('script');
    widgetLoaderScriptEl.type = 'text/javascript';
    widgetLoaderScriptEl.src = `${resourceRoot}/veeva-network-portal-widget-loader.js`;

    document.head.append(manifestScriptEl, widgetLoaderScriptEl);
  }

  /**
   * This method is the render method for this component.
   *
   * @memberof App
   * @method render
   */
  render() {
    const envType = process.env.REACT_APP_TYPE;
    const applicationType = 'NWK';
    const config = data.searchWidgetConfig[envType || 'DEV'];
    return (
      <ThemeProvider theme={theme}>

        <Container>

          <veeva-network-portal-widget
            auth-domain={config.authDomain}
            application-type={applicationType}
            search-widget-name={config.widgetName}
            search-widget-id={config.widgetId}></veeva-network-portal-widget>

        </Container>

      </ThemeProvider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/app/App.js